export default "__VITE_ASSET__BamobJ$O__"